import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  PageHeader,
  InfoBox,
  Booking,
  DownloadButton,
  PageMetadata,
  ViewBlocks,
  RichText,
  RelatedItems,
  Ticket,
} from 'iovisit-theme/components/Views';

import { When } from 'iovisit-theme/components';

const messages = defineMessages({
  eventDate: {
    id: 'event_date',
    defaultMessage: 'Data',
  },
  downloadProgram: {
    id: 'event_download_program',
    defaultMessage: 'Scarica programma',
  },
  downloadPoster: {
    id: 'event_download_poster',
    defaultMessage: 'Scarica la locandina',
  },
  related_items: {
    id: 'event_related_items',
    defaultMessage: 'Scopri gli altri eventi',
  },
  extra_info: {
    id: 'event_extra_info',
    defaultMessage: 'Per saperne di più',
  },
  timetable: { id: 'event_timetable', defaultMessage: 'Orari' },
  prices: { id: 'event_prices', defaultMessage: 'Prezzi' },
});

const EventView = ({ content, location }) => {
  const intl = useIntl();

  const timetable = RichText({
    content: content.timetable,
    title: intl.formatMessage(messages.timetable),
    titleTag: 'h3',
  });

  const prices = RichText({
    content: content.prices,
    title: intl.formatMessage(messages.prices),
    titleTag: 'h3',
  });

  return (
    <div id="page-event" className="ui container">
      <PageHeader content={{ ...content, show_share_links: true }} />
      <InfoBox>
        <h3>{intl.formatMessage(messages.eventDate)}</h3>
        <When
          start={content.start}
          end={content.end}
          whole_day={content.whole_day}
          open_end={content.open_end}
          show_times={true}
          recurrence={content.recurrence}
        />

        {timetable}

        {prices}

        <Ticket content={content} />

        <Booking content={content} />

        {content.program && (
          <DownloadButton
            file={content.program}
            title={
              content.program_title ??
              intl.formatMessage(messages.downloadProgram)
            }
          />
        )}
        {content.poster && (
          <DownloadButton
            file={content.poster}
            title={
              content.poster_title ??
              intl.formatMessage(messages.downloadPoster)
            }
          />
        )}
      </InfoBox>

      <ViewBlocks content={content} location={location} />

      {content.extra_info?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.extra_info)}
          items={content.extra_info}
          background={true}
        />
      )}

      {content.relatedItems?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_items)}
          items={content.relatedItems}
          background={(content.extra_info || []).length === 0}
        />
      )}

      <PageMetadata content={{ ...content, show_modified: true }} />
    </div>
  );
};

export default EventView;
